var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.665771 1.67108V20.3377C0.665771 21.4844 2.0151 22.0951 2.87777 21.3417L13.5444 12.0084C13.6877 11.8833 13.8024 11.7289 13.8811 11.5558C13.9597 11.3826 14.0004 11.1946 14.0004 11.0044C14.0004 10.8142 13.9597 10.6262 13.8811 10.4531C13.8024 10.2799 13.6877 10.1256 13.5444 10.0004L2.87777 0.667084C2.0151 -0.0862495 0.665771 0.52575 0.665771 1.67108ZM15.3324 1.67108V20.3377C15.3324 21.4844 16.6818 22.0951 17.5444 21.3417L28.2111 12.0084C28.3543 11.8833 28.4691 11.7289 28.5477 11.5558C28.6264 11.3826 28.6671 11.1946 28.6671 11.0044C28.6671 10.8142 28.6264 10.6262 28.5477 10.4531C28.4691 10.2799 28.3543 10.1256 28.2111 10.0004L17.5444 0.667084C16.6818 -0.0862495 15.3324 0.52575 15.3324 1.67108Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next_icon.6b3c0ebe6930a4ddafbce11d3189e0b0.svg";
export { ForwardRef as ReactComponent };